//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BottomClearance",0,"Expression",0],[1,"BoundaryBody",0,"SelectBodyList",0],[1,"CoolingStandardPart",0,"SelectNXObject",0],[0,"FittingPoint",1,"Point",0],[1,"ParentChannel",0,"SelectBodyList",0],[0,"SearchBoundaryBodies",1,0],[1,"TopClearance",0,"Expression",0],[0,"UseSymbol",1,0]],[[[],"CreateCoolingFittingData",{R_:{coolingFittingData:"Tooling.CoolingFittingData"}},0,0],[[],"GetCoolingFittingData",{R_:{coolingFittingData:"Tooling.CoolingFittingData"}},0,0],[[],"CreateFittingPoints",{},0,0],[[],"SetCoolingNodeInfo",{},0,0],[["fittingPts","channelDiameters","currentNames","currentTypes","currentFitTypes","baffleLengths","fittingPointModified","partNumbersTc"],"SetExistingFittingPointDataDetails",{},8,0],[["editPoint","newWcsMtx"],"ProcessPoint",{},2,0],[["channelType"],"SetChannelType",{},1,0],[["edit","fittingPoint"],"CalculateManualBaffleLength",{},2,0],[["coolingPart","fittingPoint"],"AddInstance",{},2,0],[["point","templateData"],"UpdateConceptPointParameters",{},2,0],[["point"],"InsertConceptSymbol",{},1,0]],[]];
SPLM.Tooling.ChannelFittingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ChannelFittingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;